import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_QUERY } from '../graphql/queries'
import { FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES } from '../redux/action-types'
import { cleanupFetchIngredientCommonNegativeSynonymPhrases } from '../redux/actions'

const useIngredientCommonNegativeSynonymPhrasesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchIngredientCommonNegativeSynonymPhrases)

  const { isLoading, error, data, latestEvent } = useSelector(
    store => store.ingredients.ingredientCommonNegativeSynonymPhrases,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_QUERY,
        {},
        dispatch,
        FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES,
      ),

    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, latestEvent }
}

export default useIngredientCommonNegativeSynonymPhrasesQuery
